import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { AuthContext } from "../context/AuthContext";
import PaginatedTable from "../components/library/Pagination";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../components/common/Loader";
import API_BASE_URL from "../config/api";

export default function PeoplePage() {
  const { token } = useContext(AuthContext);
  const navigate = useNavigate();
  const [employees, setEmployees] = useState([]);
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    jobTitle: "",
    status: "",
    searchText: "",
  });

  useEffect(() => {
    setLoading(true);
    const fetchEmployees = async () => {
      const res = await axios.get(`${API_BASE_URL}/api/employee/GetAllEmployee`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setEmployees(res.data);
      setFilteredEmployees(res.data);
    };
    fetchEmployees();
    setLoading(false)
  }, [token]);

  useEffect(() => {
    let result = employees;

    // Filter by Job Title
    if (filters.jobTitle) {
      result = result.filter(
        (emp) =>
          emp.jobTitle &&
          emp.jobTitle.toLowerCase().includes(filters.jobTitle.toLowerCase())
      );
    }

    // Filter by Status
    if (filters.status) {
      result = result.filter(
        (emp) =>
          emp.status && emp.status.toLowerCase() === filters.status.toLowerCase()
      );
    }

    // Filter by search text
    if (filters.searchText) {
      result = result.filter(
        (emp) =>
          (emp.fullName &&
            emp.fullName.toLowerCase().includes(filters.searchText.toLowerCase())) ||
          (emp.userCode &&
            emp.userCode.toLowerCase().includes(filters.searchText.toLowerCase()))
      );
    }

    setFilteredEmployees(result);
  }, [filters.searchText, employees]);



  const handleSearch = () => {
    let result = employees;
    if (filters.jobTitle) {
      result = result.filter(
        (emp) =>
          emp.jobTitle &&
          emp.jobTitle.toLowerCase().includes(filters.jobTitle.toLowerCase())
      );
    }
    if (filters.status) {
      result = result.filter(
        (emp) => emp.status && emp.status.toLowerCase() === filters.status.toLowerCase()
      );
    }
    if (filters.searchText) {
      result = result.filter(
        (emp) =>
          (emp.fullName &&
            emp.fullName.toLowerCase().includes(filters.searchText.toLowerCase())) ||
          (emp.userCode &&
            emp.userCode.toLowerCase().includes(filters.searchText.toLowerCase()))
      );
    }
    setFilteredEmployees(result);
  };

  const handleClear = () => {
    setFilters({ jobRole: "", status: "" });
    setFilteredEmployees(employees);
  };

  return (
    <>
      {loading ? (
        <Loader message="Loading..." />
      ) : (
        <div className="relative flex min-h-screen flex-col bg-white group/design-root overflow-x-hidden">
          {/* <div className="layout-container flex h-full grow flex-col">
            <div className="flex flex-1 justify-center">
              <div className="layout-content-container flex flex-col flex-1"> */}
          <div className="flex flex-wrap justify-between gap-3 p-4">
            <h1 className="text-3xl font-bold text-[#121516]">People</h1>
            <Link to="/app/addemployees">
              <button className="flex min-w-[84px] max-w-[480px] hover:bg-black hover:text-white cursor-pointer items-center justify-center overflow-hidden rounded-full h-8 px-4 bg-[#f1f3f4] text-[#121516]  text-sm font-medium leading-normal">
                <span className="truncate">+ Add Employee</span>
              </button>
            </Link>
          </div>

          <div className="px-4 py-3 overflow-x-auto">
            <div
              className="flex items-center gap-4 min-w-max"
              style={{ whiteSpace: "nowrap" }}
            >
              {/* Job Title Dropdown (distinct from employeeData) */}
              <select
                name="jobTitle"
                value={filters.jobTitle || ""}
                onChange={(e) => setFilters({ ...filters, jobTitle: e.target.value })}
                className="form-input rounded-xl border h-14 p-3 max-w-[250px]"
              >
                <option value="">Select Job Title</option>
                {[...new Set(employees.map(emp => emp.jobTitle))].map((title, index) => (
                  <option key={index} value={title}>{title}</option>
                ))}
              </select>

              {/* Status Dropdown */}
              <select
                name="status"
                value={filters.status}
                onChange={(e) => setFilters({ ...filters, status: e.target.value })}
                className="form-input rounded-xl border h-14 p-3 max-w-[250px]"
              >
                <option value="">Select Status</option>
                {[...new Set(employees.map(emp => emp.status))].map((title, index) => (
                  <option key={index} value={title}>{title}</option>
                ))}
              </select>

              {/* Buttons */}
              <div className="flex gap-3">
                <button
                  onClick={() => handleSearch()}
                  className="btn-black h-14 px-5"
                >
                  Search
                </button>

                <button
                  onClick={() => handleClear()}
                  className="cancel-btn h-14 px-5"
                >
                  Clear
                </button>
              </div>
            </div>
          </div>



          <div className="flex flex-wrap gap-4 p-4">
            <div className="flex min-w-[158px] flex-1 flex-col gap-2 rounded-xl p-6 border border-[#dde1e3]">
              <p className="text-[#121516] text-base font-medium leading-normal">
                Total Employees
              </p>
              <p className="text-[#121516] tracking-light text-2xl font-bold leading-tight">
                {employees.length}
              </p>
            </div>
            <div className="flex min-w-[158px] flex-1 flex-col gap-2 rounded-xl p-6 border border-[#dde1e3]">
              <p className="text-[#121516] text-base font-medium leading-normal">
                Active Employees
              </p>
              <p className="text-[#121516] tracking-light text-2xl font-bold leading-tight">
                {employees.filter((e) => e.status === "Confirmed").length}
              </p>
            </div>
            <div className="flex min-w-[158px] flex-1 flex-col gap-2 rounded-xl p-6 border border-[#dde1e3]">
              <p className="text-[#121516] text-base font-medium leading-normal">
                New Hires This Month
              </p>
              <p className="text-[#121516] tracking-light text-2xl font-bold leading-tight">
                {employees.filter((e) => {
                  if (e.status !== "Confirmed" || !e.startDate) return false;

                  const hireDate = new Date(e.startDate);
                  const today = new Date();

                  return (
                    hireDate.getMonth() === today.getMonth() &&
                    hireDate.getFullYear() === today.getFullYear()
                  );
                }).length}
              </p>
            </div>
          </div>
          <div className="flex justify-end w-full px-4">
            <div className="relative max-w-[250px] w-full">
              {/* Search Icon */}
              <span className="absolute inset-y-0 left-3 flex items-center text-gray-400 pointer-events-none">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M21 21l-4.35-4.35M17 10a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </span>

              {/* Input */}
              <input
                type="text"
                placeholder="Search by name"
                value={filters.searchText}
                onChange={(e) => setFilters({ ...filters, searchText: e.target.value })}
                className="rounded-md border h-14 pl-12 pr-3 w-full focus:ring-1 focus:ring-blue-400 outline-none"
              />
            </div>
          </div>


          <div className="px-4 py-3">
            <div className="flex overflow-hidden rounded-xl border border-[#dde1e3] bg-white">
              <PaginatedTable
                columns={[
                  "", // Avatar
                  "Employee",
                  // "Department",
                  "Job Role",
                  "Status",
                  "Actions",
                ]}
                data={filteredEmployees}
                pageSize={10}
                renderRow={(emp, index) => (
                  <tr key={index} className="border-t border-t-[#dde1e3]">
                    <td className="h-[72px] px-4 py-2 w-14 text-sm font-normal leading-normal">
                      <div
                        className="bg-center bg-no-repeat aspect-square bg-cover rounded-full w-10"
                        style={{
                          backgroundImage: `url('${emp.profileImageUrl
                            ? `${API_BASE_URL}/uploads/${emp.profileImageUrl}`
                            : 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png'
                            }')`,
                        }}
                      ></div>
                    </td>
                    <td className="h-[72px] px-4 py-2 text-[#121516] text-sm font-normal leading-normal">
                      <label className="font-bold">{emp.userCode}</label>
                      <br />
                      {emp.fullName}
                    </td>
                    {/* <td className="h-[72px] px-4 py-2 text-[#6a7881] text-sm font-normal leading-normal">
                        {emp.department}
                      </td> */}

                    <td className="h-[72px] px-4 py-2 text-[#6a7881] text-sm font-bold leading-normal tracking-[0.015em]">
                      {emp.jobTitle}
                    </td>

                    <td className="h-[72px] px-4 py-2 text-sm font-normal leading-normal">
                      <span className="truncate">{emp.status}</span>
                    </td>

                    <td className="h-[72px] text-sm font-normal leading-normal flex flex-wrap content-center gap-4 p-4">
                      <button onClick={() => navigate(`/app/profile/${emp.id}`)} className="btn-black">
                        <span className="truncate">View</span>
                      </button>

                      <Link
                        to={`/app/addemployees/${emp.id}`}
                        className="custom-btn"
                      >
                        <span className="truncate">Edit</span>
                      </Link>
                    </td>
                  </tr>
                )}
              />

            </div>

          </div>
        </div>
        //     </div>
        //   </div>
        // </div>
      )}
    </>
  );
}
